module.exports = __webpack_public_path__ + "static/media/Gafas graduadas.fbbba1ac.svg";